export default "__VITE_ASSET__B8LMsVp9__"